/*
 * @Author: Merlin
 * @Date: 2024-01-15 13:19:51
 * @LastEditors: Merlin
 * @LastEditTime: 2025-08-28 15:45:02
 * @Description: 
 */
import {useHiloSocket} from '@/socket/game/hilo';
import {useUserStore} from '@/stores/user';
import { Notify } from 'quasar';
import {betableCheck} from '@/common/js/betHelper';

const {
    EMIT_HILO_BET,
    EMIT_HILO_SKIP,
    EMIT_HILO_BET_HIGH,
    EMIT_HILO_BET_LOW,
    EMIT_HILO_CHESHOUT,
} = useHiloSocket();


// 👇与后端的通信的方法
export const oCommunicationFn = {
    async toSkip(){
        if (this.iSkiped >= this.iMaxSkip){ // ← 跳过次数过多
            return this.toNoticeCanNotSkip();
        }else if (!this.oGameInfo.status){  // ← 刚打开页面没押注
            return this.seeCards(); 
        }else if (!this.isStatusPlay) { // ← 每局结束后
            return; 
        }
        // ↑前端校验， ↓执行跳过
        this.oMusic.oAudio.cardChaning.toPlay();
        const res = await EMIT_HILO_SKIP();
        if (!res || res.error || !res?.round) {
            showNegativeNotify(res?.[`error`]); 
            return;
        }
        // 跳过将导致丢失 jackpot 进度
        this.oJoinStateStore.jackpotUpdate(0);
        if (import.meta.dev){
            console.log("点击了跳过", deepCopy(res));
        }
        this.oGameInfo = res;
        this.round = res.round;
    },
    // 👇用户最初打开页面时随意切换卡牌
    seeCards(){
        this.oMusic.oAudio.cardChaning.toPlay();
        this.round.push({
            card: getRandomInt(1, this.iCardsQuantity),
            key: Date.now(), // 为了动画效果
        });
        if (this.round.length > 2){
            this.round.shift();
        }
    },
    // 👇 开始游戏
    async betBtnClick(){
        if (this.isStatusPlay){
            return this.stopBetting();
        }
        const {amount} = this.oForm;
        if (!betableCheck(amount)) return;
        this.iTimesGamed++; 
        this.round = []; // ←清空，为了安全
        this.oMusic.oAudio.placeBet.toPlay();
        this.oJoinStateStore.gameRunning = true;
        const res = await EMIT_HILO_BET({
            currency: useUserStore().oNowCurrency.currencyName,
            card: this.iCardNo,
            amount,
        }).catch(err=>{
            console.log('hilo 下注出错', err); 
        });
        if (import.meta.dev){
            console.log("点击下注后返回：", res);
        }
        if (!res || res.error || !res?.round){
            this.oJoinStateStore.gameRunning = false;
            showNegativeNotify(res?.[`error`]); 
            return;
        }
        this.oGameInfo = res;
        this.round = res.round;
    },
    // 👇 结束游戏
    async stopBetting(){
        if (!this.iRoundNoSkip) return; // 没押注不能提现 
        console.log("已经退出了游戏", );
        this.oMusic.oAudio.bettingWin.toPlay();
        const res = await EMIT_HILO_CHESHOUT();
        if (!res || res.error) {
            showNegativeNotify(res?.[`error`]); 
            return;
        }
        // 返现后将重新计算
        this.oJoinStateStore.jackpotUpdate(0);
        this.oJoinStateStore.gameRunning = false;
        if (import.meta.dev){
            console.log("点击了提现", res); 
        }
        if (!res || res.error || !res?.round){
            return showNegativeNotify(res?.[`error`]); 
        }
        // 手动提现时不必变更 this.round（原站点即如此）
        this.oGameInfo = res;
        this.isShowResultPopup = true;
        setTimeout(()=>{
            this.isShowResultPopup = false;
        }, 1.5 * 1000);
    },
    async toChose(sType){
        console.time("用户选择");
        console.log("user has chosen:", sType);
        this.isClicking = true; 
        const sleepPromise = Sleep(250);
        let res;
        if (sType==='high'){
            res = await EMIT_HILO_BET_HIGH();
        }else if (sType==='low'){
            res = await EMIT_HILO_BET_LOW();
        }
        sleepPromise.then(()=>{
            this.isClicking = false; 
        });
        console.timeEnd("用户选择");
        if (!res || res.error || !res?.round){
            return showNegativeNotify(res?.[`error`]); 
        }
        if (import.meta.dev){
            console.log("押高/低：", res);
        }
        if (res.status==='play'){
            this.oMusic.oAudio.guessedCorrect.toPlay();
        }else{
            this.oMusic.oAudio.bettingLose.toPlay();
            this.oJoinStateStore.gameRunning = false;
        }
        // 点击下注时获取最新的jackpot
        this.oJoinStateStore.jackpotUpdate();
        this.$refs.jackpotHandler.showJackpotWin(); 
        this.oGameInfo = res;
        this.round = res.round;
    },
};


export const methods = {
    // 👇 控制 jackpot 弹出窗口可见性 
    jackpotControler(newVal){
        if (typeof newVal === 'boolean'){
            this.jackpotVisible = newVal;
        }else{
            this.jackpotVisible = false;
        }
    },
    // ↓弹出提示，提示不可以再跳过 
    toNoticeCanNotSkip(sError){
        const { $i18n } = useNuxtApp();
        const {t: $t} = $i18n;
        showNegativeNotify({
            type: 'warning',
            position: 'top',
            message: $t('hilo.canNotSkip').replace('●', this.iMaxSkip),
        });
    },
    betAmountChanged(val){
        // console.log("金额变更：", val); 
        this.oForm.amount = val || 0;
    },
};
